"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        borderWidth: `0 0 1px 0`,
        borderStyle: `solid`,
        borderColor: theme.grey6,
        paddingTop: 7,
        '&[data-is-borderless="true"]': {
            border: 'none'
        }
    },
    label: {
        fontSize: 10,
        fontWeight: 600,
        lineHeight: `24px`,
        color: theme.grey4,
        textTransform: `uppercase`,
        letterSpacing: 1,
        overflow: `hidden`,
        whiteSpace: `nowrap`,
        textOverflow: `ellipsis`
    },
    content: {
        display: `flex`,
        alignItems: `center`,
        marginBottom: 10
    },
    value: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: `24px`,
        color: theme.grey1,
        flexGrow: 1,
        flexShrink: 1,
        overflow: `hidden`,
        whiteSpace: `nowrap`,
        textOverflow: `ellipsis`,
        display: 'flex',
        alignItems: 'center',
        '&[data-is-idle="true"]': {
            color: theme.grey4
        }
    },
    prefix: {
        marginRight: 7,
        flexShrink: 0
    },
    action: {
        flexShrink: 0,
        minHeight: 24,
        display: 'flex',
        alignItems: 'center'
    }
});
//# sourceMappingURL=collection.item.style.js.map